import React, { Component, Fragment } from 'react'
import CardForm from 'Utils/Cards/CardForm';
import LoadMask from 'Utils/LoadMask/LoadMask';
import PasoUnoForm from './PasoUnoForm';
import PasoDosForm from './PasoDosForm';
import PasoTresForm from './PasoTresForm';
import "react-step-progress-bar/styles.css";
import {ProgressBar, Step} from "react-step-progress-bar";
import Modal from 'react-responsive-modal';
import { NotificationManager } from "react-notifications";

import ModalArchivos from './ModalArchivos';
import { OPC_MULT } from '../../../../../utility/constants';
const check = require("assets/img/icons/check.png");

export default class EjercicioExamenCreate extends Component {
    state = {
        editar: false,
        step: 1,
        modalArchivos: false,
    };
    componentWillMount(){
        this.props.obtenerArchivos();
        if(this.props.match.params.id){
            this.props.leer(this.props.match.params.id);
            this.setState({editar: true});
        }
    }
    crearForm = (values)  => {
        const data = {...values, asignatura: values.nivel.asignatura}
        data.preguntas = data.preguntas.map( item => {
            if (item.tipo == OPC_MULT) {
                item.respuestas = item.respuestas.map((_item, _index) => {
                    _item.respuesta_correcta = _index == item.respuesta_correcta;
                    return _item;
                } )
                return item
            }
            return item;
        })
        console.log("data ", data);
        this.props.crear(data);
    }
    actualizar = (values) =>{
        const data = {...values}
        data.preguntas = data.preguntas.map( item => {
            if (item.tipo == OPC_MULT) {
                item.respuestas = item.respuestas.map((_item, _index) => {
                    _item.respuesta_correcta = _index == item.respuesta_correcta;
                    return _item;
                } )
                return item
            }
            return item;
        })
        console.log("data ", data);
        this.props.editar(data, this.props.match.params.id)
    };
    nextStep = () => {
        this.setState({ step: this.state.step + 1 })
    };

    previousStep =() => {
        this.setState({ step: this.state.step - 1 })
    };
    componentWillUnmount() {
        this.props.cleanForm()
    }
    openModalArchivos = () => {
        this.setState({modalArchivos: true});
    };
    closeModal = () => {
        this.setState({modalArchivos: false});
    }
    setearArchivo = (item) => {
        this.props.setearArchivo(item);
    }

    renderModalArchivos = () => {
        return (
            <Modal
                open={this.state.modalArchivos}
                onClose={this.closeModal}
                closeIcon={false}
                showCloseIcon={false}
                center
            >
                <Fragment>
                    <div className="my-4">
                        <div className="row col-12 mx-0">
                            <span className="text-sm azul-claro bold">Selecciona los archivos para tu formulario</span>
                            <div className="d-flex w-100 bg-azul-claro" style={{ height: '3px' }} />
                        </div>
                        <div className="row col-12 mx-0">
                            <ModalArchivos
                                archivos={this.props.archivos}
                                cancelar={this.closeModal}
                                onSubmit={this.closeModal}
                                seleccionar={(item) => {
                                    this.setearArchivo(item);
                                    this.closeModal();
                                }}
                                search={this.props.search_archivos}
                                searchChange={this.props.searchChangeArchivos}
                                nivel={this.props.nivel}
                                changeNivel={this.props.changeNivel}
                            />
                        </div>
                    </div>
                </Fragment>
            </Modal>
        )
    };

    render() {
        const { crear } = this.props;
        const { updateData, loader, item } = this.props;
        const { step } = this.state;
        return (
            <div className="mb-4 col-12">
                {this.renderModalArchivos()}
                <div className="mb-5 mt-5 col-12 row d-flex justify-content-center">
                    <div className="col-sm-8 col-10 px-0">
                        <ProgressBar
                            percent={step === 1 ? 0: step === 2 ? 50 : 100}
                            filledBackground="#686A75"
                            unfilledBackground="#686A75"
                            stepPositions={[0,50,100]}
                            height={5}
                        >
                            <Step transition="scale">
                                {({ accomplished, index, position }) => (
                                    <div style={{ filter: `grayscale(${accomplished ? 0 : 80}%)` }} className="mt-3">
                                        <div className="d-flex flex-column justify-content-center align-items-center">
                                            {index + 1 === step ?
                                                <div className="step-number">
                                                    <div className="step-dot"/>
                                                </div>
                                                :
                                                (!!accomplished ?
                                                    <div className="step-checked d-flex align-items-center justify-content-center">
                                                        <img src={check} alt="" width="15" height="15"/>
                                                    </div>
                                                    :
                                                    <div className="step-number">
                                                    </div>
                                                )
                                            }
                                            <span className={`mt-2 ${index+1 === step ? 'azul': (!!accomplished ? 'azul ocultar-texto-movil' : 'gris-oscuro ocultar-texto-movil')}`}>Datos generales</span>
                                        </div>
                                    </div>
                                )}
                            </Step>
                            <Step transition="scale">
                                {({ accomplished, index, position }) => (
                                    <div style={{ filter: `grayscale(${accomplished ? 0 : 80}%)` }} className="mt-3">
                                        <div className="d-flex flex-column justify-content-center align-items-center">
                                            {index + 1 === step ?
                                                <div className="step-number">
                                                    <div className="step-dot"/>
                                                </div>
                                                :
                                                (!!accomplished ?
                                                    <div className="step-checked d-flex align-items-center justify-content-center">
                                                        <img src={check} alt="" width="15" height="15"/>
                                                    </div>
                                                    :
                                                    <div className="step-number">
                                                    </div>
                                                )
                                            }
                                            <span className={`mt-2 ${index+1 === step ? 'azul': (!!accomplished ? 'azul ocultar-texto-movil' : 'gris-oscuro ocultar-texto-movil')}`}>Formulario</span>
                                        </div>
                                    </div>
                                )}
                            </Step>
                            <Step transition="scale">
                                {({ accomplished, index, position }) => (
                                    <div style={{ filter: `grayscale(${accomplished ? 0 : 80}%)` }} className="mt-3">
                                        <div className="d-flex flex-column justify-content-center align-items-center" style={{width: 110}}>
                                            {index + 1 === step ?
                                                <div className="step-number">
                                                    <div className="step-dot"/>
                                                </div>
                                                :
                                                (!!accomplished ?
                                                    <div className="step-checked d-flex align-items-center">
                                                        <img src={check} alt="" width="15" height="15"/>
                                                    </div>
                                                    :
                                                    <div className="step-number">
                                                    </div>
                                                )
                                            }
                                            <span className={`mt-2 ${index+1 === step ? 'azul': (!!accomplished ? 'azul ocultar-texto-movil' : 'gris-oscuro ocultar-texto-movil')}`}>Carga de archivos</span>
                                        </div>
                                    </div>
                                )}
                            </Step>
                        </ProgressBar>
                        {/* <div className="mt-5 d-flex justify-content-center">
                            <button className="btn btn-secondary mr-3" onClick={this.previousStep}>Anterior</button>
                            <button className="btn btn-primary" onClick={this.nextStep}>Siguiente</button>
                        </div> */}
                    </div>
                </div>
                <CardForm>
                    <LoadMask loading={loader} blur>
                        {
                            this.state.editar ?
                                (<Fragment>
                                    {step === 1 && (
                                        <PasoUnoForm
                                            onSubmit={this.nextStep}
                                            updateData={updateData}
                                            editar={true}
                                            clearSelect={this.props.clearSelect}
                                        />
                                    )}
                                    {step === 2 && (
                                        <PasoDosForm
                                            onSubmit={this.nextStep}
                                            updateData={updateData}
                                            editar={true}
                                            previousStep={this.previousStep}
                                            marcarRespuesta={this.props.marcarRespuesta}
                                        />
                                    )}
                                    {step === 3 && (
                                        <PasoTresForm
                                            onSubmit={this.actualizar}
                                            updateData={updateData}
                                            editar={true}
                                            previousStep={this.previousStep}
                                            elegirArchivos={this.openModalArchivos}
                                            eliminarArchivo={this.props.eliminarArchivo}
                                        />
                                    )}
                                </Fragment>):

                                (<Fragment>
                                    {step === 1 && (
                                        <PasoUnoForm
                                            onSubmit={this.nextStep}
                                            editar={false}
                                            clearSelect={this.props.clearSelect}
                                        />
                                    )}
                                    {step === 2 && (
                                        <PasoDosForm
                                            onSubmit={this.nextStep}
                                            previousStep={this.previousStep}
                                            editar={false}
                                            marcarRespuesta={this.props.marcarRespuesta}
                                        />
                                    )}
                                    {step === 3 && (
                                        <PasoTresForm
                                            onSubmit={this.crearForm}
                                            previousStep={this.previousStep}
                                            editar={false}
                                            elegirArchivos={this.openModalArchivos}
                                            eliminarArchivo={this.props.eliminarArchivo}
                                        />
                                    )}
                                </Fragment>)
                        }
                    </LoadMask>
                </CardForm>
            </div>
        )
    }
  }
